/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Media_Error_In_UseInputs */

const vi_media_error_in_use = /** @type {(inputs: Media_Error_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File đang được dùng ở ${i?.count} nơi nên không xoá được. Gỡ ảnh khỏi các nơi trong mục Đang dùng ở rồi xoá lại.`)
};

/**

* @param {Media_Error_In_UseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_error_in_use = /** @type {((inputs: Media_Error_In_UseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Error_In_UseInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_error_in_use(inputs)
});